var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"search-result-text",attrs:{"tabindex":"0"}},[_vm._v("\n  "+_vm._s(_vm.setCategoryTitle(_vm.category))+" 검색결과\n  "),_c('span',{staticClass:"col-vari-blue"},[_vm._v(_vm._s(_vm.setNumberCommas(_vm.totalCount)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }